// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quiz-results-header__content[data-v-527cef47]{max-width:635px}.quiz-results-header__icon[data-v-527cef47]{text-align:center}.quiz-results-header__icon img[data-v-527cef47]{width:26px}@media(min-width:0)and (max-width:767px){.quiz-results-header__icon img[data-v-527cef47]{width:24px}}.quiz-results-header__buttons[data-v-527cef47]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
